<template>
  <div>
    <h2>Redirecionar...</h2>
  </div>
</template>

<script>
import {USER_CONFIG} from '../config/UserConfig'
import storageService from '../services/storageService'
export default {
  name: "RedirecionarPage",
  computed:{
    cliente(){        
        return storageService.getJsonItem(USER_CONFIG.clienteFormulario)
      }
  },
  methods:{
    verificarUsuarioLogado(){      
      let {participante} = this.$store.state;
      if(participante && !participante.pessoaId)
      {
        participante = storageService.getJsonItem(USER_CONFIG.loggedUser);
      }

      if(!participante){        
        this.$router.push({ path: `login` });
        return;
      }else{
         //add no state
         
        this.$store.dispatch('adicionarPessoa',participante)
        
        if(participante.bloquearNavegacao || participante.atualizarCadastro)
          {
            this.$router.push({name:'CadastroPessoaPage'})
          }
        else {
          this.$router.push({name:'ListagemFormulario', params:{apelidoCliente:this.cliente.apelidoUnico}})
        }
      }
    }
  },
  mounted(){
    //verificar se tem usuario logado, se tiver continua senão, volta para uma pagina padrão    
    this.verificarUsuarioLogado();
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/View/RedirecionarPage.vue